import { configProd } from './config.prod';
import { configDev } from './config.dev';

export const config = process.env.NODE_ENV === 'production' ? configProd : configDev;


// WEBPACK FOOTER //
// ./src/config/config.js